<template>
  <HelloWorld msg="Welcome to Your Vue.js App"/>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'App',
  components: {
    HelloWorld
  }
}
</script>

<style>
html,body{
  background-color: #d0bfea;
  box-sizing: border-box;
}
*{
  margin: 0;
  padding: 0;
}
</style>
